// src/toolbar/toolbar-context.ts
import { createContext } from "react";
var ToolbarContext = createContext(
  void 0
);

export {
  ToolbarContext
};
